// create an hash code based on the unique string (id + timestamp)
function getHashCode(input) {
  let hash = 0;
  const strLen = input.length;
  let charat;
  if (strLen === 0) {
    return hash;
  }
  for (let i = 0; i < strLen; i++) {
    charat = input.codePointAt(i);
    hash = (hash << 5) - hash + charat; // eslint-disable-line no-bitwise
    // Convert to 32bit integer
    hash &= hash; // eslint-disable-line no-bitwise
  }
  return Math.abs(hash);
}

module.exports = {
  getHashCode,
};
